module.exports = __webpack_public_path__ + "static/media/avatar.e87531d1.png";